import { useNavigate } from 'react-router-dom';
import PublicLegalPage from '@/components/PublicLegalPage';
import { CONTACT_SUPPORT_PAGE_CONTENT, PUBLIC_CORE_LINK_LABELS } from '../../ui-foundation';

export default function ContactSupportPage() {
  const navigate = useNavigate();

  return (
    <PublicLegalPage
      title={CONTACT_SUPPORT_PAGE_CONTENT.title}
      subtitle={CONTACT_SUPPORT_PAGE_CONTENT.subtitle}
      introBody={CONTACT_SUPPORT_PAGE_CONTENT.introBody}
      sections={CONTACT_SUPPORT_PAGE_CONTENT.sections}
      actions={[
        { label: PUBLIC_CORE_LINK_LABELS.about, onPress: () => navigate('/about'), tone: 'outline' },
        { label: PUBLIC_CORE_LINK_LABELS.privacy, onPress: () => navigate('/privacy'), tone: 'outline' },
        { label: PUBLIC_CORE_LINK_LABELS.gdpr, onPress: () => navigate('/gdpr'), tone: 'outline' },
        { label: PUBLIC_CORE_LINK_LABELS.communityGuidelines, onPress: () => navigate('/community-guidelines'), tone: 'outline' },
      ]}
    />
  );
}
